import { pushProductClick } from '@theme/data-layer-helper';

/**
 * Custom element that tracks clicks on promo cards for dataLayer analytics
 * Scoped to specific card instances rather than global document listener
 */
class CustomProductTile extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  /**
   * @param {MouseEvent} event
   */
  #handleClick = (event) => {
    // Check if the clicked element is an interactive element that should not trigger tracking
    const clickedElement = /** @type {HTMLElement} */ (event.target);
    const isInteractiveElement = clickedElement.closest(
      'button, [data-open-overlay], [data-add-to-cart], [data-close-overlay], add-to-cart-overlay, .add-to-cart-overlay, .overlay, .modal, .dialog'
    );
    
    // Only handle clicks that are not on interactive elements
    if (!isInteractiveElement) {
      // Find the product link within this container
      const productLink = /** @type {HTMLAnchorElement | null} */ (this.querySelector('a[href]'));
      
      if (productLink) {
        // Get product data from script tag inside this custom-product-tile element
        const scriptTag = this.querySelector('script[product-tracking-data]');
        if (!scriptTag) return;

        try {
          const productData = JSON.parse(scriptTag.textContent || '{}');
          
          // Prevent default navigation and stop event bubbling
          event.preventDefault();
          event.stopPropagation();
          
          // Push the product click event to dataLayer with the parsed data
          pushProductClick(productLink, productData);
          
          // Navigate after a small delay to ensure dataLayer push completes
          setTimeout(() => {
            window.location.href = productLink.href;
          }, 100);
        } catch (e) {
          console.error('Failed to parse product data:', e);
          // Still allow navigation even if tracking fails
          window.location.href = productLink.href;
        }
      }
    }
  };
}

if (!customElements.get('custom-product-tile')) {
  customElements.define('custom-product-tile', CustomProductTile);
}
